// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShareReferral_container__7ZjlE {
  padding: 0px;
}

.ShareReferral_shareHeaderContainer__A2ndN {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
}

.ShareReferral_shareTitle__bSHzp {
  font-family: Inter;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -3%;
  text-align: center;
  color: #333333;
  margin: 0;
}

.ShareReferral_title__l5oAc {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 14px;
}

.ShareReferral_socialIcons__a6VnL {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.ShareReferral_shareButton__1Gd\\+a {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.ShareReferral_icon__CY25j {
  width: 24px;
  height: 24px;
  display: block;
}
.ShareReferral_copyInviteButton__lBgsE {
  box-shadow: 0px 8px 8px 0px #0000000a;
  border: 2px solid #e6e6e6;
  border-radius: 12px;
  background: #ffffff;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 24px;
  margin-bottom: 24px;
}


.ShareReferral_copyInviteButton__lBgsE:hover {
  scale: calc(0.97);
}

.ShareReferral_copyInviteText__Z09Hg {
  font-family: Inter;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -3%;
  text-align: center;
  color: #333333;
  margin: 0;
  -webkit-user-select: none;
          user-select: none;
}

.ShareReferral_copyInviteIcon__N4q9w{
  width: 16px;
  height: 16px;
}

.ShareReferral_copySection__QkC6V {
  margin-top: 20px;
}

.ShareReferral_copyLabel__EA-ZQ {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 12px 0;
}

.ShareReferral_ReferralNote__4bBlU {
  font-size: 12px;
  color: #808080;
  margin-top: 10px;
  margin-bottom: 0px;
}

.ShareReferral_inputContainer__OhZsx {
  display: flex;
  gap: 0;
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  overflow: hidden;
}

.ShareReferral_inputContainer__OhZsx:focus-within {
  border-color: #bdbdbd;
}

.ShareReferral_input__LEWNw {
  flex: 1 1;
  padding: 12px 16px;
  font-size: 14px;
  color: #808080;
  border: none;
  outline: none;
  background-color: transparent;
  font-family: Inter;
}

.ShareReferral_copyButton__2FwLV {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 20px;
  background-color: #fafafa;
  border: none;
  border-left: 1px solid #e6e6e6;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  transition: all 0.2s ease;
  font-family: Inter;
  min-width: 120px;
}

.ShareReferral_copyButton__2FwLV:hover {
  background-color: #f5f5f5;
}

.ShareReferral_copyButton__2FwLV:active {
  background-color: #eeeeee;
}

.ShareReferral_copyIcon__CdmE4 {
  font-size: 16px !important;
}

@media (max-width: 480px) {
  .ShareReferral_container__7ZjlE {
    padding: 16px;
  }

  .ShareReferral_title__l5oAc {
    font-size: 16px;
  }

  .ShareReferral_socialIcons__a6VnL {
    gap: 5px;
  }

  .ShareReferral_icon__CY25j {
    width: 24px;
    height: 24px;
  }

  .ShareReferral_copySection__QkC6V {
    margin-top: 24px;
  }

  .ShareReferral_copyLabel__EA-ZQ {
    font-size: 14px;
  }

  .ShareReferral_input__LEWNw {
    font-size: 12px;
    padding: 10px 12px;
  }

  .ShareReferral_copyButton__2FwLV {
    padding: 10px 12px;
    font-size: 13px;
    gap: 4px;
    min-width: 100px;
  }

  .ShareReferral_copyIcon__CdmE4 {
    font-size: 14px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/CheckoutPage/ShareReferral/index.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".container {\n  padding: 0px;\n}\n\n.shareHeaderContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: center;\n}\n\n.shareTitle {\n  font-family: Inter;\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -3%;\n  text-align: center;\n  color: #333333;\n  margin: 0;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #333333;\n  margin-bottom: 14px;\n}\n\n.socialIcons {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.shareButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n  display: block;\n}\n.copyInviteButton {\n  box-shadow: 0px 8px 8px 0px #0000000a;\n  border: 2px solid #e6e6e6;\n  border-radius: 12px;\n  background: #ffffff;\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n\n\n.copyInviteButton:hover {\n  scale: calc(0.97);\n}\n\n.copyInviteText {\n  font-family: Inter;\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -3%;\n  text-align: center;\n  color: #333333;\n  margin: 0;\n  user-select: none;\n}\n\n.copyInviteIcon{\n  width: 16px;\n  height: 16px;\n}\n\n.copySection {\n  margin-top: 20px;\n}\n\n.copyLabel {\n  font-size: 16px;\n  font-weight: 500;\n  color: #333333;\n  margin: 0 0 12px 0;\n}\n\n.ReferralNote {\n  font-size: 12px;\n  color: #808080;\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\n.inputContainer {\n  display: flex;\n  gap: 0;\n  border-radius: 8px;\n  border: 1px solid #e6e6e6;\n  overflow: hidden;\n}\n\n.inputContainer:focus-within {\n  border-color: #bdbdbd;\n}\n\n.input {\n  flex: 1;\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #808080;\n  border: none;\n  outline: none;\n  background-color: transparent;\n  font-family: Inter;\n}\n\n.copyButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 12px 20px;\n  background-color: #fafafa;\n  border: none;\n  border-left: 1px solid #e6e6e6;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333333;\n  transition: all 0.2s ease;\n  font-family: Inter;\n  min-width: 120px;\n}\n\n.copyButton:hover {\n  background-color: #f5f5f5;\n}\n\n.copyButton:active {\n  background-color: #eeeeee;\n}\n\n.copyIcon {\n  font-size: 16px !important;\n}\n\n@media (max-width: 480px) {\n  .container {\n    padding: 16px;\n  }\n\n  .title {\n    font-size: 16px;\n  }\n\n  .socialIcons {\n    gap: 5px;\n  }\n\n  .icon {\n    width: 24px;\n    height: 24px;\n  }\n\n  .copySection {\n    margin-top: 24px;\n  }\n\n  .copyLabel {\n    font-size: 14px;\n  }\n\n  .input {\n    font-size: 12px;\n    padding: 10px 12px;\n  }\n\n  .copyButton {\n    padding: 10px 12px;\n    font-size: 13px;\n    gap: 4px;\n    min-width: 100px;\n  }\n\n  .copyIcon {\n    font-size: 14px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ShareReferral_container__7ZjlE`,
	"shareHeaderContainer": `ShareReferral_shareHeaderContainer__A2ndN`,
	"shareTitle": `ShareReferral_shareTitle__bSHzp`,
	"title": `ShareReferral_title__l5oAc`,
	"socialIcons": `ShareReferral_socialIcons__a6VnL`,
	"shareButton": `ShareReferral_shareButton__1Gd+a`,
	"icon": `ShareReferral_icon__CY25j`,
	"copyInviteButton": `ShareReferral_copyInviteButton__lBgsE`,
	"copyInviteText": `ShareReferral_copyInviteText__Z09Hg`,
	"copyInviteIcon": `ShareReferral_copyInviteIcon__N4q9w`,
	"copySection": `ShareReferral_copySection__QkC6V`,
	"copyLabel": `ShareReferral_copyLabel__EA-ZQ`,
	"ReferralNote": `ShareReferral_ReferralNote__4bBlU`,
	"inputContainer": `ShareReferral_inputContainer__OhZsx`,
	"input": `ShareReferral_input__LEWNw`,
	"copyButton": `ShareReferral_copyButton__2FwLV`,
	"copyIcon": `ShareReferral_copyIcon__CdmE4`
};
export default ___CSS_LOADER_EXPORT___;
